import { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, TimeInput } from 'components';
import styled from 'styled-components';
import { Template, daysOfTheWeekArray } from 'types/template';

interface RecordingScheduleProps {
    templateSetter: Dispatch<SetStateAction<Template>>;
    template: Template;
}

const InputWrapper = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 5px;
`;

const TimeWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    margin-left: 20px;
`;

const RecordingSchedule: FC<RecordingScheduleProps> = ({
    templateSetter,
    template
}: RecordingScheduleProps) => {
    const { t } = useTranslation();
    if (!template.schedule.enabled) return null;

    return (
        <InputWrapper>
            {daysOfTheWeekArray.map((day) => (
                <Button
                    key={day}
                    size="small"
                    type={
                        template.schedule.days.includes(day)
                            ? 'contained'
                            : 'outlined'
                    }
                    onClick={() => {
                        let newDays = template.schedule.days;
                        const currentIndex =
                            template.schedule.days.indexOf(day);

                        if (currentIndex !== -1) {
                            newDays.splice(currentIndex, 1);
                        } else {
                            newDays.push(day);
                        }

                        templateSetter({
                            ...template,
                            schedule: {
                                ...template.schedule,
                                days: newDays
                            }
                        });
                    }}>
                    {day}
                </Button>
            ))}
            <TimeWrapper>
                <TimeInput
                    label={t('general.from')}
                    required
                    value={`${template.schedule.time.fromHours
                        .toString()
                        .padStart(2, '0')}:${template.schedule.time.fromMinutes
                        .toString()
                        .padStart(2, '0')}`}
                    onChange={(event) => {
                        const value = event.target.value;
                        templateSetter({
                            ...template,
                            schedule: {
                                ...template.schedule,
                                time: {
                                    ...template.schedule.time,
                                    fromHours: parseInt(value.split(':')[0]),
                                    fromMinutes: parseInt(value.split(':')[1])
                                }
                            }
                        });
                    }}
                    validate={() =>
                        template.schedule.time.toHours ===
                            template.schedule.time.fromHours &&
                        template.schedule.time.toMinutes ===
                            template.schedule.time.fromMinutes
                    }
                />
                <TimeInput
                    required
                    label={t('general.to')}
                    value={`${template.schedule.time.toHours
                        .toString()
                        .padStart(2, '0')}:${template.schedule.time.toMinutes
                        .toString()
                        .padStart(2, '0')}`}
                    onChange={(event) => {
                        const value = event.target.value;
                        templateSetter({
                            ...template,
                            schedule: {
                                ...template.schedule,
                                time: {
                                    ...template.schedule.time,
                                    toHours: parseInt(value.split(':')[0]),
                                    toMinutes: parseInt(value.split(':')[1])
                                }
                            }
                        });
                    }}
                    validate={() =>
                        template.schedule.time.toHours ===
                            template.schedule.time.fromHours &&
                        template.schedule.time.toMinutes ===
                            template.schedule.time.fromMinutes
                    }
                />
            </TimeWrapper>
        </InputWrapper>
    );
};

export default RecordingSchedule;
